"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
function getAllMetadata(target, keys) {
    return keys.reduce((acc, key) => {
        acc[key] = Reflect.getMetadata(key, target);
        return acc;
    }, {});
}
exports.default = getAllMetadata;
